module.exports = __webpack_public_path__ + "static/media/donate-balance.8230cf93.svg";